/**
 * Scroll a paginated list container back to the top after creating a new item.
 */
export function scrollListToTop(container: HTMLElement | null | undefined): void {
  container?.scrollTo({ top: 0, left: 0 });
}

/**
 * Scroll the list container when it is scrollable; otherwise bring a fallback element
 * (e.g. the list header) into view at the top of the viewport.
 */
export function scrollListToTopWithFallback(
  container: HTMLElement | null | undefined,
  fallbackElement?: HTMLElement | null | undefined
): void {
  if (container && container.scrollHeight > container.clientHeight) {
    container.scrollTo({ top: 0, left: 0 });
    return;
  }
  fallbackElement?.scrollIntoView({ block: 'start' });
}

/** Run scroll reset after the DOM has painted refreshed list content. */
export function scrollListToTopAfterPaint(
  container: HTMLElement | null | undefined,
  fallbackElement?: HTMLElement | null | undefined
): void {
  requestAnimationFrame(() => {
    if (fallbackElement) {
      scrollListToTopWithFallback(container, fallbackElement);
    } else {
      scrollListToTop(container);
    }
  });
}
